(function () {
  var el     = document.getElementById('cart-frame-upsell');
  var popout = document.getElementById('cfu-popout');
  var toggle = document.getElementById('cfu-toggle');
  var list   = document.getElementById('cfu-list');
  var selEl  = document.getElementById('cfu-selected');
  var addBtn = document.getElementById('cfu-add');
  var feedback = document.getElementById('cfu-feedback');
  var choices = document.getElementById('cfu-choices');
  if (!el || !toggle || !list || !addBtn) return;

  var frameProducts = null;
  var selectedVariantId = null;
  var targetPrint = null;
  var route = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';

  // ── Helpers ───────────────────────────────────────────────
  var norm = function (s) { return s ? s.toLowerCase().replace(/\s/g, '') : ''; };

  function matchVariant(variants, posterSize) {
    if (!posterSize) return variants.find(function (v) { return v.available; }) || variants[0];
    var pn = norm(posterSize);
    var match = variants.find(function (v) { return norm(v.title) === pn; });
    if (!match) match = variants.find(function (v) { var t = norm(v.title); return pn.includes(t) || t.includes(pn); });
    if (!match) {
      var dims = posterSize.match(/(\d+)\s*[x×]\s*(\d+)/i);
      if (dims) match = variants.find(function (v) { return norm(v.title).includes(dims[1] + 'x' + dims[2]); });
    }
    return match || null;
  }

  function fmtPrice(cents) {
    // The locale-aware Ajax Product API returns presentment-currency subunits.
    cents = Number(cents);
    if (!Number.isFinite(cents)) return '';

    var format = (window.theme && window.theme.moneyFormat) || '€{{amount_with_comma_separator}}';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    function withDelimiters(number, precision, thousands, decimal) {
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }

    var value;
    switch ((format.match(placeholderRegex) || [])[1]) {
      case 'amount_no_decimals':
        value = withDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        value = withDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = withDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = withDelimiters(cents, 2, "'", '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = withDelimiters(cents, 0, ' ', '');
        break;
      case 'amount_with_space_separator':
        value = withDelimiters(cents, 2, ' ', ',');
        break;
      case 'amount_with_period_and_space_separator':
        value = withDelimiters(cents, 2, ' ', '.');
        break;
      default:
        value = withDelimiters(cents, 2, ',', '.');
    }

    return '+ ' + format.replace(placeholderRegex, value);
  }

  // ── Load frames (cached) ──────────────────────────────────
  function loadFrames() {
    if (frameProducts) return Promise.resolve(frameProducts);
    var data = document.getElementById('cart-frame-products');
    if (!data) return Promise.resolve([]);
    try {
      frameProducts = JSON.parse(data.textContent);
      return Promise.resolve(frameProducts);
    } catch (error) {
      console.error('[cart-frame-upsell] Invalid frame data', error);
      return Promise.resolve([]);
    }
  }

  // ── Evaluate cart & show/hide ─────────────────────────────
  function evaluate() {
    return Promise.all([
      fetch(route + 'cart.js').then(function (r) { if (!r.ok) throw Error('cart'); return r.json(); }),
      loadFrames()
    ]).then(function (results) {
      var cart    = results[0];
      var frames  = results[1];
      var frameIds = new Set(frames.map(function (p) { return p.id; }));

      var FRAMING_SERVICE_VARIANT = 71051195187222;
      var matching = window.DcCartPairing.match(cart, frameIds, FRAMING_SERVICE_VARIANT);
      targetPrint = matching.unframed[0] || null;
      selectedVariantId = null;
      addBtn.disabled = true;
      feedback.hidden = true;
      if (targetPrint) {
        document.getElementById('cfu-context').textContent = targetPrint.product_title + ' · ' + (targetPrint.variant_title || '');
        renderOptions(frames, targetPrint.variant_title);
        el.style.display = choices.children.length ? '' : 'none';
      } else {
        el.style.display = 'none';
      }
    }).catch(function () {});
  }

  // ── Swatch color from product title ──────────────────────
  var SWATCH_MAP = [
    { test: 'dark oak',  color: '#6b4226' },
    { test: 'oak',       color: '#c8a96e' },
    { test: 'black',     color: '#1a1a1a' },
    { test: 'white',     color: '#f0ede8' },
    { test: 'walnut',    color: '#5c3317' },
    { test: 'natural',   color: '#c8a96e' },
    { test: 'gold',      color: '#c9a96e' },
    { test: 'silver',    color: '#c0c0c0' },
  ];
  function swatchColor(title) {
    var t = (title || '').toLowerCase();
    for (var i = 0; i < SWATCH_MAP.length; i++) {
      if (t.indexOf(SWATCH_MAP[i].test) >= 0) return SWATCH_MAP[i].color;
    }
    return '#d4cfc9';
  }

  // ── Render frame options ──────────────────────────────────
  function renderOptions(frames, posterSize) {
    list.querySelectorAll('[data-frame-opt]').forEach(function (n) { n.remove(); });
    choices.replaceChildren();

    frames.forEach(function (product) {
      var handle = product.handle || '';
      var finish = handle === 'dark-oak-frame' ? 'dark oak' : handle === 'oak-frame' ? 'oak' : handle === 'black-wooden-frame' ? 'black' : handle === 'white-wooden-frame' ? 'white' : '';
      if (!finish || choices.querySelector('[data-finish="' + finish + '"]')) return;
      var variant = matchVariant(product.variants, posterSize);
      if (!variant || !variant.available || !window.DcCartPairing.size({variant_title: variant.title}) || window.DcCartPairing.size({variant_title: variant.title}) !== window.DcCartPairing.size({variant_title: posterSize})) return;

      var li = document.createElement('li');
      li.className = 'cfu__item';
      li.setAttribute('role', 'option');
      li.setAttribute('aria-selected', 'false');
      li.setAttribute('data-value', variant.id);
      li.setAttribute('data-frame-opt', '');
      var color = swatchColor(product.title);
      var swatch = document.createElement('span'); swatch.className = 'cfu__swatch'; swatch.style.backgroundColor = color;
      var label = document.createElement('span'); label.className = 'cfu__item-label'; label.textContent = product.title;
      var price = document.createElement('span'); price.className = 'cfu__item-price'; price.textContent = fmtPrice(variant.price);
      li.append(swatch, label, price);
      list.appendChild(li);
      var choice = document.createElement('button');
      choice.type = 'button'; choice.className = 'cfu__choice';
      choice.dataset.variantId = variant.id;
      choice.dataset.finish = finish;
      choice.setAttribute('aria-pressed', 'false');
      var image = document.createElement('img');
      image.alt = ''; image.loading = 'lazy';
      var frameDetailImages = {
        'oak': 'https://decollective.co/cdn/shop/files/oakframe-thumnail.webp',
        'dark oak': 'https://decollective.co/cdn/shop/files/darkoakframe-thumnail.webp',
        'black': 'https://decollective.co/cdn/shop/files/blackframe-thumnail.webp',
        'white': 'https://decollective.co/cdn/shop/files/whiteframe-thumnail.webp'
      };
      image.src = frameDetailImages[finish];
      var names = {
        'dark oak': ['Mörk ek', 'Roble oscuro', 'Dark oak'],
        'oak': ['Ek', 'Roble', 'Oak'],
        'black': ['Svart', 'Negro', 'Black'],
        'white': ['Vit', 'Blanco', 'White']
      };
      var localeIndex = el.dataset.locale === 'sv' ? 0 : el.dataset.locale === 'es' ? 1 : 2;
      var name = document.createElement('span'); name.textContent = names[finish][localeIndex];
      var choicePrice = document.createElement('span'); choicePrice.textContent = fmtPrice(variant.price);
      choice.append(image, name, choicePrice);
      choices.appendChild(choice);
    });
  }

  choices.addEventListener('click', function (event) {
    var choice = event.target.closest('.cfu__choice');
    if (!choice) return;
    choices.querySelectorAll('.cfu__choice').forEach(function (item) { item.setAttribute('aria-pressed', String(item === choice)); });
    selectedVariantId = parseInt(choice.dataset.variantId, 10);
    addBtn.disabled = false;
  });

  // ── Dropdown toggle ───────────────────────────────────────
  // The list is position:fixed and moved to <body> (not left inside
  // .cfu__popout) for two reasons: (1) the cart drawer body scrolls with
  // overflow:hidden/auto, which clips an absolutely-positioned popout once
  // the cart has enough items to scroll, and (2) the drawer's slide-in
  // animation applies a CSS transform to an ancestor, and position:fixed
  // is computed relative to the nearest transformed ancestor rather than
  // the viewport — so without moving it out, "fixed" coordinates land in
  // the wrong place. Appending to <body> sidesteps both.
  if (list.parentElement !== document.body) {
    document.body.appendChild(list);
  }

  function positionList() {
    var rect = toggle.getBoundingClientRect();
    list.style.top = (rect.bottom + 4) + 'px';
    list.style.left = rect.left + 'px';
    list.style.width = rect.width + 'px';
  }

  function closeList() {
    toggle.setAttribute('aria-expanded', 'false');
    list.hidden = true;
  }

  var drawerBody = document.querySelector('.drawer__body');

  toggle.addEventListener('click', function (e) {
    e.stopPropagation();
    var isOpen = toggle.getAttribute('aria-expanded') === 'true';
    if (isOpen) {
      closeList();
    } else {
      positionList();
      toggle.setAttribute('aria-expanded', 'true');
      list.hidden = false;
    }
  });

  document.addEventListener('click', function (e) {
    if (!popout.contains(e.target) && !list.contains(e.target)) {
      closeList();
    }
  });

  // Reposition (or just close) if the drawer scrolls or the window resizes
  // while the list is open, so it doesn't end up floating in the wrong spot.
  if (drawerBody) drawerBody.addEventListener('scroll', function () {
    if (!list.hidden) closeList();
  });
  window.addEventListener('resize', function () {
    if (!list.hidden) closeList();
  });

  // ── Select item ───────────────────────────────────────────
  list.addEventListener('click', function (e) {
    var item = e.target.closest('.cfu__item');
    if (!item) return;

    list.querySelectorAll('.cfu__item').forEach(function (i) {
      i.classList.remove('cfu__item--active');
      i.setAttribute('aria-selected', 'false');
    });
    item.classList.add('cfu__item--active');
    item.setAttribute('aria-selected', 'true');

    var swatch = item.querySelector('.cfu__swatch').cloneNode(true);
    var label  = item.querySelector('.cfu__item-label').textContent;
    selEl.innerHTML = '';
    selEl.appendChild(swatch);
    var span = document.createElement('span');
    span.className = 'cfu__selected-label';
    span.textContent = label;
    selEl.appendChild(span);

    toggle.setAttribute('aria-expanded', 'false');
    list.hidden = true;

    var val = item.dataset.value;
    selectedVariantId = (val && val !== 'none') ? parseInt(val, 10) : null;
    addBtn.disabled = !selectedVariantId;
  });

  // ── Add frame to cart ─────────────────────────────────────
  addBtn.addEventListener('click', function () {
    if (!selectedVariantId || !targetPrint) return;
    el.classList.add('is-loading');
    addBtn.disabled = true;

    fetch(route + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: selectedVariantId, quantity: 1, properties: Object.assign({ '_print_key': targetPrint.key }, targetPrint.properties && targetPrint.properties._pair ? { '_pair': targetPrint.properties._pair } : {}) })
    }).then(function (response) {
      if (!response.ok) throw new Error('Frame could not be added');
      el.style.display = 'none';
      var cartItemsEl = document.querySelector('cart-items');
      if (cartItemsEl && typeof cartItemsEl.getCart === 'function') {
        cartItemsEl.getCart();
      }
    }).catch(function (err) {
      console.error('[cart-frame-upsell]', err);
      feedback.textContent = el.dataset.locale === 'sv' ? 'Ramen kunde inte läggas till. Försök igen.' : el.dataset.locale === 'es' ? 'No se pudo añadir el marco. Inténtalo de nuevo.' : 'Could not add the frame. Please try again.';
      feedback.hidden = false;
      addBtn.disabled = false;
    }).finally(function () {
      el.classList.remove('is-loading');
    });
  });

  // ── Debounced re-evaluate on cart changes ────────────────
  var _evalTimer = null;
  function scheduleEval(ms) {
    clearTimeout(_evalTimer);
    _evalTimer = setTimeout(evaluate, ms || 200);
  }

  // On the cart page there is no drawer, so evaluate as soon as it loads.
  var _drawerOpen = !!document.querySelector('[data-cart-page]');
  if (_drawerOpen) scheduleEval(50);
  document.addEventListener('theme:cart-drawer:open', function () {
    _drawerOpen = true;
    scheduleEval(50);
  });
  document.addEventListener('theme:product:added', function () {
    _drawerOpen = true;
    scheduleEval(500);
  });
  document.addEventListener('theme:cart:change', function () {
    if (_drawerOpen) scheduleEval(200);
  });
})();
